// DEPENDENCIES
import React from "react";

// CSS
import "./PendingAmendmentCard.css";

// CONSTANTS
import { convertToPST } from "../../../../constants/dateTime";

// COMPONENT
const PendingAmendmentCard = (props) => {
	// STATES

	// CONTEXT

	// USE EFFECT

	return (
		<div
			className="PendingAmendmentCard"
			onClick={props.pendingAmendmentClicked}
		>
			<div className="pendingAmendmentCardTitle">
				{props.amendment?.hubspot_deal_name}
			</div>
			<div className="pendingAmendmentCardTags">
				<div className="oicTag">
					{convertToPST(props.amendment?.created)}
				</div>
				{/* <div className="dealOwnerTag">
					{props.amendment?.deal_owner}
				</div> */}
			</div>
		</div>
	);
};

export default PendingAmendmentCard;
